module.exports = __webpack_public_path__ + "img/ttshop_tk1.36f7359b.svg";